<script lang="ts">
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import type { HeadingStoryblok } from '$types/bloks';

  export let block: HeadingStoryblok;
</script>

<section class="px-2 py-12 lg:px-8 lg:py-16">
  <div
    class="container isolate mx-auto flex flex-col text-center gap-2"
    use:storyblokEditable={block}
  >
    <h2 class="text-8xl font-semibold w-full md:w-4/12 mx-auto">{block.title}</h2>
    <p class="text-2xl w-full md:w-4/12 mx-auto">{block.text}</p>
  </div>
</section>
